@if (action == 'index') {
	<div class="container">
		<div class="d-flex justify-content-between align-items-center">
			<h1 class="fs-2 fw-light mt-4">Choose Property - Notices</h1>
			<button (click)="goHome()" class="btn btn-primary">Home <fa-icon [icon]="faHouseChimney"></fa-icon></button>
		</div>

		<div class="form-group has-search my-3">
			<fa-icon class="form-control-feedback" [icon]="faSearch"></fa-icon>
			<input type="text" name="searchProperty" [(ngModel)]="searchProperty" class="form-control" placeholder="Search by property name" />
		</div>

		@if (loadingProperties) {
			<div class="my-4">
				<span class="spinner-border spinner-border-sm mr-1"></span>
				<span>Loading properties...</span>
			</div>
		}

		@if (!loadingProperties && properties.length == 0) {
			<div class="alert alert-info">No properties found.</div>
		}

		<ul class="list-group list-group-flush col-md-6">
			@for (property of properties | filter: searchProperty ; track property) {
				<li (click)="onSelectedProperty(property)" class="fs-3 text-primary list-group-item list-group-item-action d-flex justify-content-between align-items-center">
					@if (property.property_type == 'house') {
						<fa-icon class="l-icon" [icon]="faHouse"></fa-icon>
					}
					@if (property.property_type == 'strata') {
						<fa-icon class="l-icon" [icon]="faBuilding"></fa-icon>
					}
					@if (property.property_type == 'Townhouse') {
						<fa-icon class="l-icon" [icon]="faHouseChimney"></fa-icon>
					}
					<span class="text-black fw-lighter">{{property.name}} </span>
					<fa-icon [icon]="faCircleArrowRight"></fa-icon>
				</li>
			}
		</ul>
	</div>
}

@if (action != 'index' && !property?.id) {
	<div class="container">
		<h1 class="fs-2 fw-light mt-4">Manage Notices</h1>
		<div class="alert alert-warning mt-4">
			No property selected. Choose a property first to manage notices.
		</div>
		<button (click)="goBack()" type="button" class="btn btn-primary">
			<fa-icon [icon]="faCircleArrowLeft"></fa-icon> Back
		</button>
	</div>
}

@if (action != 'index' && property?.id && properties.length > 1) {
	<div class="container mt-3">
		<button (click)="onChangeProperty()" type="button" class="btn btn-sm btn-outline-secondary">Change property</button>
	</div>
}

@if (property?.id && action == 'create') {
	<div class="container">
		<h1 class="fs-2 fw-light mt-4">Create Notice</h1>
		<form [formGroup]="addNoticeForm">
			<div class="row">
				<div class="col-md-4 form-group my-2">
					<label class="form-label" for="unitNumber">Unit Number</label>
					<input class="form-control" id="unitNumber" type="number" formControlName="unit_number" [ngClass]="{ 'is-invalid': submitNoticeData && fna.unit_number.errors }" />
				</div>
				<div class="col-md-4 form-group my-2">
					<label class="form-label" for="dateVisible">Visible From</label>
					<input class="form-control" id="dateVisible" type="date" formControlName="dateVisible" [ngClass]="{ 'is-invalid': submitNoticeData && fna.dateVisible.errors }" />
				</div>
				<div class="col-md-4 form-group my-2">
					<label class="form-label" for="propertyName">Property</label>
					<input class="form-control" id="propertyName" type="text" formControlName="propertyName" readonly />
					<input type="hidden" formControlName="propertyId" />
				</div>
			</div>

			<div class="form-group my-3">
				<label class="form-label" for="shortDescription">Short Description</label>
				<input class="form-control" id="shortDescription" type="text" formControlName="shortDescription" [ngClass]="{ 'is-invalid': submitNoticeData && fna.shortDescription.errors }" />
			</div>

			<div class="form-group my-3">
				<label class="form-label" for="longDescription">Long Description</label>
				<textarea class="form-control" id="longDescription" rows="5" formControlName="longDescription" [ngClass]="{ 'is-invalid': submitNoticeData && fna.longDescription.errors }"></textarea>
			</div>
		</form>
	</div>
}

@if (property?.id && action == 'edit') {
	<div class="container">
		<h1 class="fs-2 fw-light mt-4">Edit Notice</h1>
		<form [formGroup]="editNoticeForm">
			<input type="hidden" formControlName="id" />

			<div class="row">
				<div class="col-md-4 form-group my-2">
					<label class="form-label" for="editUnitNumber">Unit Number</label>
					<input class="form-control" id="editUnitNumber" type="number" formControlName="unit_number" [ngClass]="{ 'is-invalid': submitNoticeData && fne.unit_number.errors }" />
				</div>
				<div class="col-md-4 form-group my-2">
					<label class="form-label" for="editDateVisible">Visible From</label>
					<input class="form-control" id="editDateVisible" type="date" formControlName="dateVisible" [ngClass]="{ 'is-invalid': submitNoticeData && fne.dateVisible.errors }" />
				</div>
				<div class="col-md-4 form-group my-2">
					<label class="form-label" for="editPropertyName">Property</label>
					<input class="form-control" id="editPropertyName" type="text" formControlName="propertyName" readonly />
					<input type="hidden" formControlName="propertyId" />
				</div>
			</div>

			<div class="form-group my-3">
				<label class="form-label" for="editShortDescription">Short Description</label>
				<input class="form-control" id="editShortDescription" type="text" formControlName="shortDescription" [ngClass]="{ 'is-invalid': submitNoticeData && fne.shortDescription.errors }" />
			</div>

			<div class="form-group my-3">
				<label class="form-label" for="editLongDescription">Long Description</label>
				<textarea class="form-control" id="editLongDescription" rows="5" formControlName="longDescription" [ngClass]="{ 'is-invalid': submitNoticeData && fne.longDescription.errors }"></textarea>
			</div>
		</form>
	</div>
}

@if (property?.id && action == 'view') {
	<div class="container">
		<div class="d-flex justify-content-between align-items-center">
			<h1 class="fs-2 fw-light mt-4">View Notice</h1>
			<button (click)="onEditNotice()" type="button" class="mt-4 btn btn-primary">
				Edit <fa-icon [icon]="faPenToSquare"></fa-icon>
			</button>
		</div>

		<form [formGroup]="viewNoticeForm">
			<div class="row">
				<div class="col-md-4 form-group my-2">
					<label class="form-label">Unit Number</label>
					<input class="form-control" type="number" formControlName="unit_number" readonly />
				</div>
				<div class="col-md-4 form-group my-2">
					<label class="form-label">Visible From</label>
					<input class="form-control" type="date" formControlName="dateVisible" readonly />
				</div>
				<div class="col-md-4 form-group my-2">
					<label class="form-label">Property</label>
					<input class="form-control" type="text" formControlName="propertyName" readonly />
				</div>
			</div>

			<div class="form-group my-3">
				<label class="form-label">Short Description</label>
				<input class="form-control" type="text" formControlName="shortDescription" readonly />
			</div>

			<div class="form-group my-3">
				<label class="form-label">Long Description</label>
				<textarea class="form-control" rows="5" formControlName="longDescription" readonly></textarea>
			</div>
		</form>
	</div>
}

@if (property?.id && action == 'list') {
	<div class="container">
		<div class="d-flex justify-content-between align-items-center">
			<h1 class="fs-2 fw-light mt-4">Manage Notices</h1>
			<button (click)="onCreateNotice()" type="button" class="mt-4 btn btn-primary">
				Add <fa-icon [icon]="faCirclePlus"></fa-icon>
			</button>
		</div>

		<p class="text-muted">Property: {{ property.name }}</p>

		<div class="form-group has-search my-3">
			<fa-icon class="form-control-feedback" [icon]="faSearch"></fa-icon>
			<input type="text" name="searchNotice" [(ngModel)]="searchNotice" class="form-control" placeholder="Search notices" />
		</div>

		@if (loading) {
			<div class="my-4">
				<span class="spinner-border spinner-border-sm mr-1"></span>
				<span>Loading notices...</span>
			</div>
		}

		@if (!loading && notices.length == 0) {
			<div class="alert alert-info">No notices found for this property. Create your first notice.</div>
		}

		<ul class="list-group list-group-flush">
			@for (notice of notices; track notice.id) {
				@if ((notice.shortDescription + ' ' + notice.longDescription).toLowerCase().includes(searchNotice.toLowerCase())) {
					<li class="list-group-item">
						<button class="btn btn-link text-start p-0 text-decoration-none w-100" type="button" (click)="onSelectedNotice(notice)">
							<div class="d-flex justify-content-between align-items-center">
								<div>
									<strong class="text-primary">{{ notice.shortDescription }}</strong>
									<div class="text-muted small mt-1">{{ notice.longDescription }}</div>
									<div class="text-secondary small mt-1">Unit {{ notice.unit_number }} | Visible: {{ notice.dateVisible | date: 'MMM d, y' }}</div>
								</div>
								<fa-icon [icon]="faCircleArrowRight"></fa-icon>
							</div>
						</button>
					</li>
				}
			}
		</ul>
	</div>
}

@if (property?.id) {
	<div class="mt-4 d-flex container justify-content-between align-items-center">
		<button (click)="goBack()" type="button" class="btn btn-primary">
			<fa-icon [icon]="faCircleArrowLeft"></fa-icon> Back
		</button>

		@if (action == 'create') {
			<button [disabled]="fetching" class="btn btn-primary" (click)="createNotice()">
				Save
				@if (!fetching) {
					<fa-icon [icon]="faPaperPlane"></fa-icon>
				}
				@if (fetching) {
					<span class="spinner-border spinner-border-sm mr-1"></span>
				}
			</button>
		}

		@if (action == 'edit') {
			<div class="d-flex gap-2">
				<button [disabled]="fetching" class="btn btn-danger" (click)="onDeleteNotice()">
					Delete <fa-icon [icon]="faTrash"></fa-icon>
				</button>
				<button [disabled]="fetching" class="btn btn-info" (click)="updateNotice()">
					Update
					@if (!fetching) {
						<fa-icon [icon]="faPaperPlane"></fa-icon>
					}
					@if (fetching) {
						<span class="spinner-border spinner-border-sm mr-1"></span>
					}
				</button>
			</div>
		}

		@if (action == 'view') {
			<button [disabled]="fetching" class="btn btn-danger" (click)="onDeleteNotice()">
				Delete <fa-icon [icon]="faTrash"></fa-icon>
			</button>
		}
	</div>
}
